import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, createTextVNode as _createTextVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = { class: "rounded bg-white p-3 mb-4" };
const _hoisted_2 = { class: "d-flex justify-content-end" };
const _hoisted_3 = ["src"];
import { FilterMatchMode } from '@primevue/core/api';
import DataTable from "primevue/datatable";
import Column from "primevue/column";
import TenantLayout from '@/Tenant/Layouts/TenantLayout.vue';
import { Head, Link } from '@inertiajs/vue3';
import { onMounted, ref } from 'vue';
import { formatters } from '@/Composables/formatters';
export default /*@__PURE__*/ _defineComponent({
    __name: 'Index',
    props: {
        images: Object
    },
    setup(__props) {
        let { formatDate } = formatters();
        const props = __props;
        onMounted(() => {
        });
        const tableFilter = ref({
            'global': { value: null, matchMode: FilterMatchMode.CONTAINS }
        });
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock(_Fragment, null, [
                _createVNode(_unref(Head), { title: "Konfigurationen" }),
                _createVNode(TenantLayout, null, {
                    default: _withCtx(() => [
                        _cache[4] || (_cache[4] = _createElementVNode("h1", { class: "fw-bold mb-3" }, "Ki-Bilder", -1)),
                        _createElementVNode("div", _hoisted_1, [
                            _createVNode(_unref(DataTable), {
                                dataKey: "id",
                                value: props.images,
                                stripedRows: "",
                                responsiveLayout: "scroll",
                                globalFilterFields: ['designTopic', 'designType', 'industry', 'applicationArea', 'createdAt', 'updatedAt'],
                                filters: tableFilter.value,
                                "onUpdate:filters": _cache[1] || (_cache[1] = ($event) => ((tableFilter).value = $event)),
                                paginator: true,
                                rows: 10,
                                paginatorTemplate: "CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown",
                                rowsPerPageOptions: [10, 25, 50, 150],
                                currentPageReportTemplate: "{first} von {last} von insgesamt {totalRecords}"
                            }, {
                                header: _withCtx(() => [
                                    _createElementVNode("div", _hoisted_2, [
                                        _withDirectives(_createElementVNode("input", {
                                            type: "text",
                                            class: "form-control",
                                            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((tableFilter.value['global'].value) = $event)),
                                            placeholder: "Suche",
                                            style: { "width": "250px" }
                                        }, null, 512), [
                                            [_vModelText, tableFilter.value['global'].value]
                                        ])
                                    ])
                                ]),
                                empty: _withCtx(() => [...(_cache[2] || (_cache[2] = [
                                        _createElementVNode("div", { class: "p-3" }, " Keine Einträge gefunden ", -1)
                                    ]))]),
                                loading: _withCtx(() => [...(_cache[3] || (_cache[3] = [
                                        _createTextVNode(" Einträge werden geladen ... ", -1)
                                    ]))]),
                                default: _withCtx(() => [
                                    _createVNode(_unref(Column), { header: "Bild" }, {
                                        body: _withCtx((slotProps) => [
                                            _createElementVNode("img", {
                                                src: _ctx.route('configurator.imageUrlLoader.configuratorAiImage', slotProps.data.uuid),
                                                alt: "Generated Image",
                                                style: { "width": "300px", "height": "auto" },
                                                class: "border border-dark",
                                                loading: "lazy"
                                            }, null, 8, _hoisted_3)
                                        ]),
                                        _: 1
                                    }),
                                    _createVNode(_unref(Column), {
                                        field: "colorScheme",
                                        header: "Farb-Schema",
                                        sortable: true,
                                        sortField: "colorScheme"
                                    }),
                                    _createVNode(_unref(Column), {
                                        field: "colors",
                                        header: "Farben",
                                        sortable: true,
                                        sortField: "colors"
                                    }),
                                    _createVNode(_unref(Column), {
                                        field: "printType",
                                        header: "Drucktyp",
                                        sortable: true,
                                        sortField: "printType"
                                    }),
                                    _createVNode(_unref(Column), {
                                        field: "isFullDesign",
                                        header: "Komplett-Design?",
                                        sortable: true,
                                        sortField: "isFullDesign"
                                    }),
                                    _createVNode(_unref(Column), {
                                        field: "designTopic",
                                        header: "Thema",
                                        sortable: true,
                                        sortField: "designTopic"
                                    }),
                                    _createVNode(_unref(Column), {
                                        field: "designType",
                                        header: "Design-Typ",
                                        sortable: true,
                                        sortField: "designType"
                                    }),
                                    _createVNode(_unref(Column), {
                                        field: "industry",
                                        header: "Branche",
                                        sortable: true,
                                        sortField: "industry"
                                    }),
                                    _createVNode(_unref(Column), {
                                        field: "applicationArea",
                                        header: "Nutzung",
                                        sortable: true,
                                        sortField: "applicationArea"
                                    }),
                                    _createVNode(_unref(Column), {
                                        field: "aiModel",
                                        header: "AI-Model",
                                        sortable: true,
                                        sortField: "aiModel"
                                    }),
                                    _createVNode(_unref(Column), {
                                        field: "inputToken",
                                        header: "Eingabe-Token",
                                        sortable: true,
                                        sortField: "inputToken"
                                    }),
                                    _createVNode(_unref(Column), {
                                        field: "outputToken",
                                        header: "Ausgabe-Token",
                                        sortable: true,
                                        sortField: "outputToken"
                                    }),
                                    _createVNode(_unref(Column), {
                                        field: "creationTime",
                                        header: "Erstellungszeit (s)",
                                        sortable: true,
                                        sortField: "creationTime"
                                    }),
                                    _createVNode(_unref(Column), {
                                        header: "Erstellt",
                                        sortable: true,
                                        sortField: "createdAt"
                                    }, {
                                        body: _withCtx((slotProps) => [
                                            _createVNode(_unref(Link), {
                                                href: _ctx.route('admin.configurations.edit', slotProps.data.configurationUuid)
                                            }, {
                                                default: _withCtx(() => [
                                                    _createTextVNode(_toDisplayString(_unref(formatDate)(slotProps.data.createdAt, true)), 1)
                                                ]),
                                                _: 2
                                            }, 1032, ["href"])
                                        ]),
                                        _: 1
                                    })
                                ]),
                                _: 1
                            }, 8, ["value", "filters"])
                        ])
                    ]),
                    _: 1
                })
            ], 64));
        };
    }
});
